import React, {FC} from 'react';
import {Section} from 'templates/reports/query';
import {parseResults} from 'templates/reports/Section/RmrEstimate/parse';

import * as styles from './styles.module.scss';

type DataTableProps = {
	rmr: Section
}

const DataTable: FC<DataTableProps> = ({rmr}) => {
	const {headings, rows} = parseResults(rmr);
	return (
		<div className={styles.wrapper}>
			<table className={styles.table}>
				<thead>
					<tr>
						<th>Date</th>
						{headings.map((h, i) => <th key={i}>{h}</th>)}
					</tr>
				</thead>
				<tbody>
					{rows.map((r, i) => (
						<tr key={i}>
							<td>
								{rmr.results[i].start.full}
							</td>
							{headings.map((h, j) => (
								<td key={`${i}:${j}`}>
									{r[h]} kcal
								</td>
							))}
						</tr>
					))}
				</tbody>
			</table>
		</div>
	);
};

export default DataTable;
